export default {
      id: "unit_type_flatbed-usage",
      viewBox: "0 0 45 16",
      url: __webpack_public_path__ + "img/icons.svg#unit_type_flatbed",
      toString: function () {
        return this.url;
      }
    }